import { render, staticRenderFns } from "./thirdParty.vue?vue&type=template&id=02f97736"
import script from "./thirdParty.vue?vue&type=script&lang=js"
export * from "./thirdParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f97736')) {
      api.createRecord('02f97736', component.options)
    } else {
      api.reload('02f97736', component.options)
    }
    module.hot.accept("./thirdParty.vue?vue&type=template&id=02f97736", function () {
      api.rerender('02f97736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/thirdParty.vue"
export default component.exports